import supabaseClient from '@/api/supabaseClient';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

const useDeleteUserAccount = () => {
  const client = supabaseClient;

  return useMutation({
    mutationFn: () => deleteUserAccount(client),
  });
};

export default useDeleteUserAccount;

async function deleteUserAccount(client: SupabaseClient): Promise<void> {
  const { error } = await client.functions.invoke('delete_user_account');

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse = await error.context.json();

    throw new Error(errorResponse.errors.join(', '));
  }
}

